export const enumContratForFormation = {
    ALTSTAGE : 1,
    CDDCDIINTERIM : 2
}